import { Flex, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { AGGridCellRenderParams } from "~/pages/Compliance/ComplianceTable/types";

interface Props {
  params: AGGridCellRenderParams;
}

export const LegacyKycCellRenderer = ({ params }: Props) => {
  const isYes = params.value !== "No";
  const color = isYes ? Colors.Danger600 : Colors.Success600;
  return (
    <Flex alignItems="center" gap={4} css={{ height: "100%" }}>
      <Icon
        type={isYes ? "exclamation-circle" : "check"}
        color={color}
        data-testid="case-status-icon"
        data-cy="case-status-icon"
      />
      <Text data-testid="profile-name-label" variant="strong-md" css={{ color }}>
        {params.value}
      </Text>
    </Flex>
  );
};
